import { createFileRoute } from '@tanstack/react-router';

import { requireRoute } from '@/router/guards';
import GroupEdit from '@/ui/pages/GroupEdit/GroupEdit';

export const Route = createFileRoute('/_dashboard/groups/new')({
  beforeLoad: requireRoute('/groups/new'),
  component: GroupEdit,
});
